var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { transformAndValidateSync } from "class-transformer-validator";
import { IsBoolean, IsOptional } from "class-validator";
export class RetrievalStatsConfig {
}
__decorate([
    IsBoolean(),
    IsOptional()
], RetrievalStatsConfig.prototype, "recordSummary", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], RetrievalStatsConfig.prototype, "resourceIdStats", void 0);
export const retrievalStatsConfigDecoder = (rawConfig) => {
    if (!rawConfig)
        return null;
    try {
        const parsed = JSON.parse(rawConfig);
        if (typeof parsed !== "object" || parsed === null || Array.isArray(parsed))
            return null;
        return transformAndValidateSync(RetrievalStatsConfig, parsed, {
            validator: { whitelist: true, forbidNonWhitelisted: true },
        });
    }
    catch {
        return null;
    }
};
export const resolveRetrievalStatsToggles = (config) => ({
    recordSummary: (config === null || config === void 0 ? void 0 : config.recordSummary) !== false,
    resourceIdStats: (config === null || config === void 0 ? void 0 : config.resourceIdStats) !== false,
});
